import { render, staticRenderFns } from "./NewRequestForm.vue?vue&type=template&id=172a384e&scoped=true&"
import script from "./NewRequestForm.vue?vue&type=script&lang=js&"
export * from "./NewRequestForm.vue?vue&type=script&lang=js&"
import style0 from "./NewRequestForm.vue?vue&type=style&index=0&id=172a384e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172a384e",
  null
  
)

export default component.exports